import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { getRequest, postFileRequest, download, downloadFileObject } from '@/plugins/api-axios'
import { getFileContentHash } from '@/utils/file'

@Mixin
export default class AttachmentMixin extends Vue {
    url_attachment = process.env.VUE_APP_ATTACHMENT_BASE_URL

    get headersmixins() {
        return {
            'Content-Type': 'application/vnd.api+json',
        }
    }

    getFile(fileId: string) {
        return `${this.url_attachment}/files/${fileId}`
    }

    getPreview(fileId: string) {
        return `${this.url_attachment}/files/${fileId}/preview`
    }

    getProjectLogo(id: string) {
        return this.$store.getters.project(id)?.attributes.avatarFileId
            ? `${this.url_attachment}/files/${
                  this.$store.getters.project(id)?.attributes.avatarFileId
              }/`
            : null
    }

    async getFileRequirements() {
        let url = `${this.url_attachment}/uploadRequirements`
        let res = await getRequest(url, this.headersmixins)
        this.$store.commit('attachmentConstraints', res.data)
        return res.data
    }

    async postFile(params: any, returnError = false, isAnonymousUser = false) {
        const name = params.name || params.filename || ''
        let fileId: any = null
        let nameArray = name.split('.')
        let fileType = '.' + nameArray.pop().toLowerCase()
        let fileName = encodeURIComponent(nameArray.join('.'))
            .replace(/['()]/g, escape)
            .replace(/\*/g, '%2A')
            .replace(/%(?:7C|60|5E)/g, unescape)
        let url = `${this.url_attachment}/files`

        const baseHeaders = {
            'Content-Checksum': `${await getFileContentHash(params)}`,
            'Content-Type': params.type,
        }

        // Trial upload
        let trialHeaders = {
            ...(isAnonymousUser ? { Authorization: 'Session kAbU3KEwjUQTJIJIaPI8qt' } : {}),
            ...baseHeaders,
            'Content-Disposition': `attachment; filename*=UTF-8''${fileName + fileType}; size=${
                params.size
            } `,
        }

        let res = await postFileRequest(url, trialHeaders).catch((error) => {
            error.data.response.data.errors.map((error: any) => {
                if (error.detail == "The header 'Content-Disposition' contained an invalid value") {
                    this.$store.dispatch('errorSnackbar', 'Wrong file name')
                } else {
                    this.$store.dispatch('errorSnackbar', 'Problems with uploading the file')
                }
            })

            if (returnError) throw error
        })

        if (res && res.data.status == '200') {
            fileId = res.data.data.fileId
        }

        // No existing files upload
        if (res && res.data.status == '204') {
            let headers = {
                ...(isAnonymousUser ? { Authorization: 'Session kAbU3KEwjUQTJIJIaPI8qt' } : {}),
                ...baseHeaders,
                'Content-Disposition': `attachment; filename*=UTF-8''${fileName + fileType} `,
            }

            let file = await postFileRequest(url, headers, params).catch((error) => {
                this.$store.dispatch('errorSnackbar', 'Problems with uploading the file')
            })
            fileId = file.data.data.fileId
        }

        return fileId
    }

    async downloadAttachment(fileId: string, filename: string, isAnonymousUser = false) {
        console.log('downloadSelectedAttachment', isAnonymousUser)

        let url = `${this.url_attachment}/files/${fileId}/`
        let res = await download(
            url,
            {
                ...this.headersmixins,
                ...(isAnonymousUser ? { Authorization: 'Session kAbU3KEwjUQTJIJIaPI8qt' } : {}),
            },
            filename
        )
        return res
    }

    async downloadAttachmentAsFileObject(fileId: string, isAnonymousUser = false) {
        let url = `${this.url_attachment}/files/${fileId}/`
        let res = await downloadFileObject(url, {
            ...this.headersmixins,
            ...(isAnonymousUser ? { Authorization: 'Session kAbU3KEwjUQTJIJIaPI8qt' } : {}),
        })
        return res
    }
}
